import { useLocation as useRouterLocation } from 'react-router-dom';
import { useMemo } from 'react';

export interface LocationHook<T> {
    pathname: string;
    state: T;
}

export function useLocation<T>(): LocationHook<T> {
    const location = useRouterLocation();

    return useMemo(
        () => ({
            pathname: location.pathname,
            state: location.state,
        }),
        [location.pathname]
    );
}
